import { HttpError } from '../models/httpClient.models';

export const getServerErrorMessage = (error: unknown): string | undefined => {
  if (
    error instanceof HttpError &&
    typeof error.internalError === 'object' &&
    error.internalError &&
    'data' in error.internalError &&
    typeof error.internalError.data === 'object' &&
    error.internalError.data &&
    'error' in error.internalError.data &&
    typeof error.internalError.data.error === 'string'
  ) {
    return error.internalError.data.error;
  }
  return undefined;
};

export const isNotFoundError = (error: unknown): boolean =>
  error instanceof HttpError && error.status === 404;

const delay = (delayMs: number) =>
  new Promise((resolve) => setTimeout(resolve, delayMs));

export const retryOnNotFound = async <T>(
  fn: () => Promise<T>,
  { attempts = 3, delayMs = 1500 } = {}
): Promise<T> => {
  for (let attempt = 1; attempt < attempts; attempt++) {
    try {
      return await fn();
    } catch (error) {
      if (!isNotFoundError(error)) {
        throw error;
      }
      await delay(delayMs);
    }
  }
  return fn();
};
